import classNames from "classnames";
import "./OpticksMessage.css";
import CheckCircleIcon from "../OpticksIcons/CheckCircleIcon";
import AlertCircleIcon from "../OpticksIcons/AlertCircleIcon";
import AlertTriangleIcon from "../OpticksIcons/AlertTriangleIcon";
import InfoCircleIcon from "../OpticksIcons/InfoCircleIcon";
import ShieldCancelIcon from "../OpticksIcons/ShieldCancelIcon";

interface Props {
  children: React.ReactNode;
  paddingSize?: "xs" | "s" | "m";
  type?: "ghost" | "info" | "success" | "warning" | "error" | "blocked";
  width?: "full";
}

const OpticksMessage = ({
  children,
  paddingSize = "s",
  type = "ghost",
  width,
}: Props) => {
  const renderIcon = (type: string) => {
    switch (type) {
      case "info":
        return <InfoCircleIcon size={20} className="icon-deep-blue" />;
      case "success":
        return <CheckCircleIcon size={20} className="icon-traffic-legitimate-darker" />;
      case "warning":
        return <AlertCircleIcon size={20} className="icon-traffic-suspicious-dark" />;
      case "error":
        return (
          <AlertTriangleIcon size={20} className="icon-traffic-invalid-darker" />
        );
      case "blocked":
        return <ShieldCancelIcon size={20} className="icon-white" />;
      default:
        return null;
    }
  };

  return (
    <div
      className={classNames(
        "opticks-message",
        { [`padding-${paddingSize}`]: paddingSize },
        { [`type-${type}`]: type },
        { [`width-${width}`]: width }
      )}
    >
      {type !== "ghost" && <div className="icon">{renderIcon(type)}</div>}
      <span className="children">{children}</span>
    </div>
  );
};

export default OpticksMessage;
